'use client';

import { ServiceActionCardProps } from './ServiceActionCard.props';
import ActionCard from '../ActionCard/ActionCard';
import Image from '@repo/ui/Image';
import Chip from '@repo/ui/Chip';
import { VpIcon, VpAsset, VpAssetName } from '@vtmn-play/react';

import './ServiceActionCard.scss';

const ServiceActionCard = ({
  action,
  as,
  category,
  className,
  description,
  duration,
  extra,
  i18n = { showDescription: 'Show description' },
  id,
  imageSrc,
  categoryType,
  name = '',
  price,
  remoteCountries,
}: ServiceActionCardProps) => {
  return (
    <ActionCard
      action={action}
      as={as}
      className={className}
      i18n={{ showTertiary: i18n.showDescription }}
      id={id}
      illustration={
        imageSrc && (
          <Image
            className='service-card-image'
            alt={name}
            height={54}
            src={imageSrc}
            width={54}
          />
        )
      }
      primary={<p className='service-card-title'>{name}</p>}
      secondary={
        (price || duration) && (
          <div className='service-card-tags'>
            {category && (
              <Chip
                className={
                  categoryType &&
                  `service-card-tag--${categoryType?.toLowerCase()}`
                }
                variant={categoryType ? undefined : 'primary'}
              >
                <div className='service-card-category'>{category}</div>
              </Chip>
            )}
            {price && (
              <Chip id='service-card-tags-price' variant='catchy'>
                {price}
              </Chip>
            )}
            {duration && (
              <Chip variant='brand' className='service-card-duration'>
                <VpIcon name='time' size={12} strokeWidth={2} /> {duration}
              </Chip>
            )}
            {remoteCountries?.map((country) => (
              <Chip key={`id-${country}`} className='service-card-remote'>
                <VpAsset
                  name={`flag-${country.toLowerCase()}` as VpAssetName}
                  height={12}
                />
              </Chip>
            ))}
          </div>
        )
      }
      extra={extra}
      tertiary={description}
    />
  );
};

export default ServiceActionCard;
